<template>
    <div>

        <ShareModal ref="shareModal" :project="project"></ShareModal>
        <Breadcrumbs @shareToWeb="shareToWeb" @exportAsPdf="exportAsPdf" :show-download="role == 'editor'"
                     show-path="true"
                     title="Pitch"/>

        <div class="pt-2">

            <div class="blog-details-main col-6 text-center mt-2" style="margin: 0 auto">
                <h2 class="blog-bottom-details" v-if="project && locale">
                    {{ project.translation['en'].name }}
                </h2>
                <h5>
                     <span><i class="fa fa-star font-warning"></i><i class="fa fa-star font-warning"></i><i
                             class="fa fa-star font-warning"></i><i class="fa fa-star font-warning"></i><i
                             class="fa fa-star font-warning"></i></span>
                </h5>
                <hr>
                <ul class="blog-social">
                    <li class="digits" v-if="project && locale">
                        {{
                        project.translation['en'].description
                        }}
                    </li>
                </ul>
            </div>

            <div class="card mt-4">
                <div class="card-body">
                    <div class="row text-center">
                        <div class="col-lg-6" v-for="category in categories" :key="category.id">
                            <ProjectDropdown
                                    v-if="project && project.categories.length"
                                    :role="role"
                                    :category="category"
                                    :project="project"
                                    @updateSelected="updateSelected">
                            </ProjectDropdown>
                        </div>
                    </div>
                    <div v-if="project && project.sections.length && sections.length">
                        <ProjectTextArea
                                v-for="record in project.sections"
                                :role="role"
                                :key="record.id"
                                :section="record"
                                :project="project"
                                @updateSection="updateSection"
                        ></ProjectTextArea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import ProjectDropdown from "@/pages/Projects/ProjectEdit/ProjectDropdown";
import ProjectTextArea from "@/pages/Projects/ProjectEdit/ProjectTextArea";
import ShareModal from "@/pages/Projects/ProjectEdit/ShareModal";

export default {
    components: {ShareModal, ProjectDropdown, ProjectTextArea},
    data() {
        return {
            project: null,
            sections: [],
            categories: [],
            loaded: false
        };
    },
    async created() {

        this.$store.dispatch('shared/setLoading', true)

        this.project = await this.$store.dispatch('projects/getProject', this.$route.params.id)

        let categoryRequest = await this.$store.dispatch('projects/getCategories', this.project.group_id);

        //Merge plan categories with original one
        this.project.categories.forEach((item) => {
            item.original = categoryRequest.find((record) => {
                return record.id == item.original_id
            })
        })

        let mainCategories = this.project.categories.filter((item) => {
            return item.original != undefined && item.original && item.original.parent_id == null
        })

        mainCategories.forEach((category) => {
            category.subCategory = this.project.categories.filter((item) => {
                return item.original != undefined && item.original.parent_id == category.original.id
            })
        })

        this.$set(this, 'categories', mainCategories);

        let sections = await this.$store.dispatch('projects/getSections', this.project.group_id);

        this.project.sections.forEach((item) => {
            item.original = sections.find((record) => {
                return record.id == item.original_id
            })

        })

        this.$set(this, 'sections', sections)

        this.$store.dispatch('shared/setLoading', false)


    },
    methods: {

        shareToWeb() {
            this.$refs.shareModal.openModal()
        },
        exportAsPdf() {
        },
        async setCategories() {

            let categoryRequest = await this.$store.dispatch('projects/getCategories', this.project.group_id);

            let mainCategories = categoryRequest.filter((item) => {
                return item.parent_id == null
            })

            mainCategories.forEach((category) => {

                category.subCategory = categoryRequest.filter((item) => {
                    item.selectedId = 0
                    return item.parent_id == category.id
                })

            })

            mainCategories.forEach((category) => {
                if (category.subCategory.length && this.project.categories.length) {

                    let currentCategory = this.project.categories.find((item) => {
                        return item.original_id == category.id
                    })

                    if (currentCategory) {
                        category.selectedId = parseInt(currentCategory.description, 10)
                    }
                }
            })

            this.$set(this, 'categories', mainCategories);

            return categoryRequest
        },

        async setSections() {

            let sections = await this.$store.dispatch('projects/getSections', this.project.group_id);
            this.$set(this, 'sections', sections)

            return sections
        },

        async updateSection(data) {

            let saveObject = {
                id: data.id,
                name: data.answer
            }

            await this.$store.dispatch('projects/updateSingleSection', saveObject);
        },

        async updateSelected(data) {

            let saveObject = {
                id: data.category.id,
                name: data.item.id
            }

            let response = await this.$store.dispatch('projects/updateSingleCategory', saveObject);

            if (response.status && response.status == 200) {

                let edited = this.project.categories.find((item) => {
                    return item.id == saveObject.id
                })

                if (edited) {
                    this.$set(edited, 'name', saveObject.name)
                }

            }
        }
    },
    computed: {
        locale: function () {
            return this.$i18n.locale
        },
        role: function () {
            let user = this.$store.getters['shared/getUser']

            if (!user) {
                return null
            }

            if (!this.project) {
                return null
            }

            let currentUserRoles = this.project.share.find((item) => {
                return item.user_id == user.id
            })

            return {
                content: currentUserRoles.is_editor ? 'editor' : currentUserRoles.is_mentor ? 'mentor' : 'reader',
                personal: this.project.user_id == user.id
            }
        }
    }
};
</script>

<style>

.card h5 {
    color: #7366ff;
}

.card, .card-body, .card .card-header {
    padding: 10px !important;
}

.single-select .list-group {
    z-index: 100;
}

</style>